// extracted by mini-css-extract-plugin
module.exports = {"Notification_fail":"Notification_Notification_fail__1fB9g","Notification_warn":"Notification_Notification_warn__2chMV"};